export default __webpack_public_path__ + "static/media/pokerChip.152b458a.mp3";